<template>
  <div>
    <template>
      <div v-if="loading"><a-skeleton active /></div>
      <div v-else>
        <template v-if="createdForm && createdForm.id">
          <ViewForm />
        </template>
        <!-- Neeus khong co du lieu tren DB -->
        <template v-else>
          <template v-if="!workflowId">
            <h3>Khởi tạo tệp trình duyệt</h3>

            <NewForm :fileUrl="fileUrl" :workflowId="workflowId" />
          </template>
          <template v-else>
            <a-result
              status="500"
              title="Không tìm thấy URL"
              subTitle="Tệp văn bản này không được hỗ trợ hoặc không đúng!"
            />
          </template>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import gql from "graphql-tag";
import { mapMutations } from "vuex";

import { getContentControlText } from "@/services/contentControl";

import NewForm from "./NewForm.vue";
import ViewForm from "./ViewForm.vue";

export default {
  components: {
    NewForm,
    ViewForm
  },
  data() {
    return {
      fileUrl: undefined,
      loading: false,
      workflowId: undefined
    };
  },
  methods: {
    ...mapMutations({
      setForm: "form/setForm"
    }),

    getCreatedForm(id) {
      this.loading = true;
      if (id) {
        this.$apollo
          .query({
            query: gql`
              query getCreatedForm($id: ID!) {
                createdForm(id: $id) {
                  id
                  title
                  code
                  description
                  approvalStatus
                  approvalCurrentStep
                  approvalTotalStep
                  form {
                    id
                    formName
                  }
                  createdFormFields {
                    id
                    name
                    code
                    description
                    type
                    value
                    options {
                      canAddValueManual
                      canChoiceMultiple
                      choices
                      defaultValue
                      friendlyFormat
                      includeTime
                      isRequireValue
                      setMax
                      setMin
                    }
                    createdAt
                    updatedAt
                  }
                  approvalSteps {
                    id
                    approvalCurrentStep
                    approvalStatus
                    approvalNote
                    createdAt
                    author {
                      username
                      fullname
                      department {
                        name
                      }
                      position {
                        name
                      }
                    }
                  }
                  currentApprovalStep {
                    stepOrder
                    stepName
                    user
                    department
                    position
                  }
                  currentApprovers {
                    id
                    username
                    fullname
                  }
                  author {
                    id
                    username
                  }
                  createdAt
                  updatedAt
                }
              }
            `,
            variables: { id }
          })
          .then(data => {
            this.loading = false;
            if (!data.error || !data.errors) {
              this.setForm(data.data.createdForm);
            }
          })
          .catch(error => {
            console.log("Lỗi", error);
            this.loading = false;
          });
      }
    }
  },
  computed: {
    createdForm() {
      return this.$store.state.form;
    }
  },
  async created() {
    // Lấy fileUrl của Word
    // Office.context.document.getFilePropertiesAsync((asyncResult) => {
    //   this.fileUrl = asyncResult.value.url;
    //   this.getCreatedForm();
    // });

    // Lấy ID của file Word
    const workflowId = await getContentControlText();
    if (workflowId) {
      this.workflowId = workflowId;
      this.getCreatedForm(workflowId);
    }
  }
};
</script>
